/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskSignalsAnalysisStatus } from "../funcs/riskSignalsAnalysisStatus.js";
import { riskSignalsGet } from "../funcs/riskSignalsGet.js";
import { riskSignalsMcpServerCounts } from "../funcs/riskSignalsMcpServerCounts.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { RiskAnalysisStatusResult } from "../models/components/riskanalysisstatusresult.js";
import { RiskMcpServerCountsResult } from "../models/components/riskmcpservercountsresult.js";
import { RiskSignalsResult } from "../models/components/risksignalsresult.js";
import {
  GetRiskAnalysisStatusRequest,
  GetRiskAnalysisStatusSecurity,
} from "../models/operations/getriskanalysisstatus.js";
import {
  GetRiskMcpServerCountsRequest,
  GetRiskMcpServerCountsSecurity,
} from "../models/operations/getriskmcpservercounts.js";
import {
  GetRiskSignalsRequest,
  GetRiskSignalsSecurity,
} from "../models/operations/getrisksignals.js";
import { unwrapAsync } from "../types/fp.js";

export class Signals extends ClientSDK {
  /**
   * getRiskAnalysisStatus risk
   *
   * @remarks
   * Get the run state of the project's risk analysis coordinator, which produces the findings behind the Watchdog page. Analysis is signal-driven, not scheduled: the coordinator wakes within about 30 seconds of new chat traffic and never runs on a timer, so a quiet project can legitimately go a long time between runs. The state is never when no run is visible (the project has never been analyzed, or its last run is older than Temporal's retention window), idle when the latest run has closed and the coordinator is waiting for the next chat write, and running when a run is in flight.
   */
  async analysisStatus(
    request?: GetRiskAnalysisStatusRequest | undefined,
    security?: GetRiskAnalysisStatusSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskAnalysisStatusResult> {
    return unwrapAsync(riskSignalsAnalysisStatus(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getRiskMcpServerCounts risk
   *
   * @remarks
   * Get live finding counts per concrete MCP server over a window, largest first. Powers the MCP server filter pickers on Risk Events and Watchdog. Served from the ClickHouse findings store.
   */
  async mcpServerCounts(
    request?: GetRiskMcpServerCountsRequest | undefined,
    security?: GetRiskMcpServerCountsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskMcpServerCountsResult> {
    return unwrapAsync(riskSignalsMcpServerCounts(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getRiskSignals risk
   *
   * @remarks
   * Get clustered risk signals — findings grouped by rule and ranked by severity score — plus window-level KPI stats and the exposure breakdown by category. Powers the Watchdog page. Served from the ClickHouse findings store.
   */
  async get(
    request?: GetRiskSignalsRequest | undefined,
    security?: GetRiskSignalsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskSignalsResult> {
    return unwrapAsync(riskSignalsGet(
      this,
      request,
      security,
      options,
    ));
  }
}
